import { useQuery } from '@tanstack/react-query';

import dtStatus from '../../status';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function useDtPortfolioByCode(stockCode) {
  const { cb, key } = fetch();

  const { isDtActive } = dtStatus.useDtAccountStatus();

  const enabled =
    isDtActive && // Do not call when user does not have DT account
    !!stockCode; // Do not call without stock code

  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled,
    staleTime: 5000,
    cacheTime: 5000,
    refetchOnWindowFocus: false,
  });

  // Fetch all DT portfolio
  // Then filter data based on given stockCode
  const _data = data?.portfolio?.find((v) => v.stock === stockCode) || null;

  /**
   * Number of lots owned by the user that can be put in a new Sell order.
   * Lots currently being locked on other features cannot be sold.
   *
   * - lot              : lot owned by user
   * - sellot           : lot currently being held on an open sell order
   * - freeze_asset_lot : lot currently being held due to TP/SL
   * */
  const dtAvailableLot = (_data?.lot || 0) - ((_data?.selllot || 0) + (_data?.freezeAssetLot || 0));

  return { data: _data, isSuccess, refetch, dtAvailableLot };
}

export default useDtPortfolioByCode;
